import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import BotaoVoltar from "../components/BotaoVoltar";

export default function NewCheckin() {
  const navigate = useNavigate();

  const [desafios, setDesafios] = useState([]);
  const [desafioSelecionado, setDesafioSelecionado] = useState("");
  const [dadosDesafio, setDadosDesafio] = useState(null);

  const [evidencia, setEvidencia] = useState(null);
  const [observacao, setObservacao] = useState("");
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [loading, setLoading] = useState(false);

  // Carrega os desafios do dia
  useEffect(() => {
    api
      .get("/desafios/dia/")
      .then((res) => setDesafios(res.data))
      .catch((err) => console.error(err));
  }, []);

  // Quando usuário seleciona um desafio, então busca suas características completas
  const handleSelectDesafio = (id) => {
    setDesafioSelecionado(id);

    if (!id) {
      setDadosDesafio(null);
      return;
    }

    api
      .get(`/desafios/${id}/`)
      .then((res) => setDadosDesafio(res.data))
      .catch((err) => {
        console.error(err);
        setDadosDesafio(null);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    if (!desafioSelecionado) {
      setErro("Selecione um desafio.");
      return;
    }

    const formData = new FormData();
    formData.append("desafio", desafioSelecionado);
    if (evidencia) formData.append("evidencia", evidencia);
    if (observacao) formData.append("observacao", observacao);

    setLoading(true);

    try {
      await api.post("/checkins/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSucesso("Check-in enviado com sucesso!");
      setTimeout(() => navigate("/checkins"), 1000);
    } catch (err) {
      console.error(err);
      setErro("Erro ao enviar o check-in. Verifique os campos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="container mt-4" style={{ maxWidth: "600px" }}>
        <div className="text-end">
          <BotaoVoltar to="/checkins"/>
        </div>
        <h2 className="fw-bold mb-4">⭐ Novo Check-in</h2>

        {erro && <div className="alert alert-danger">{erro}</div>}
        {sucesso && <div className="alert alert-success">{sucesso}</div>}

        <div className="card shadow-sm p-4">
          
          {/* SELECT DO DESAFIO */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Desafio do dia</label>

            <select
              className="form-select"
              value={desafioSelecionado}
              onChange={(e) => handleSelectDesafio(e.target.value)}
            >
              <option value="">Selecione um desafio...</option>

              {desafios.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.emoji} {d.titulo}
                </option>
              ))}
            </select>

            {desafios.length === 0 && (
              <div className="text-muted small mt-1">
                Nenhum desafio disponível hoje.
              </div>
            )}
          </div>

          {/* EXIBIR CARACTERÍSTICAS DO DESAFIO */}
          {dadosDesafio && (
            <div className="border rounded p-3 mb-3 bg-light">
              <h6 className="fw-bold mb-2">
                {dadosDesafio.emoji} {dadosDesafio.titulo}
              </h6>

              <p className="mb-1">
                <strong>Tipo:</strong> {dadosDesafio.tipo_nome}
              </p>

              <p className="mb-1">
                <strong>Sprint:</strong> {dadosDesafio.sprint}
              </p>

              <p className="mb-0">
                <strong>Descrição:</strong> {dadosDesafio.descricao}
              </p>
            </div>
          )}

          {/* EVIDÊNCIA */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Evidência</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) => setEvidencia(e.target.files[0])}
            />
            <small className="text-muted">Opcional</small>
          </div>

          {/* OBSERVAÇÃO */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Observação</label>
            <textarea
              className="form-control"
              rows="3"
              placeholder="Descreva seu avanço..."
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
            />
          </div>

          {/* BOTÃO */}
          <button
            className="btn btn-primary w-100 py-2"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Enviando..." : "Enviar Check-in"}
          </button>
        </div>
      </div>
    </>
  );
}
